import { createFileRoute } from "@tanstack/react-router"
import { MerchantsTab } from "./_merchants-tab"

export const Route = createFileRoute("/settings/merchants")({
  component: MerchantsTab,
})
